import { render } from "./PasswordResetView.vue?vue&type=template&id=27e8ff54"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/PasswordResetView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27e8ff54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27e8ff54', __exports__)) {
    api.reload('27e8ff54', __exports__)
  }
  
  module.hot.accept("./PasswordResetView.vue?vue&type=template&id=27e8ff54", () => {
    api.rerender('27e8ff54', render)
  })

}


export default __exports__